import { render, staticRenderFns } from "./modalAgregarProductos.vue?vue&type=template&id=6f815228&"
import script from "./modalAgregarProductos.vue?vue&type=script&lang=js&"
export * from "./modalAgregarProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports